import React, { useEffect, useState } from "react";
import ClinicalProgressionMetrics from "./ClinicalProgressionMetrics";
import DispositionOptionContent from "./DispositionOptionContent";
import DispositionOptionTabs from "./DispositionOptionTabs";
import type { PredictiveDispositionPanelProps } from "./types";

const PredictiveDispositionPanel: React.FC<PredictiveDispositionPanelProps> = ({
  options,
  metrics,
  workingDrg,
  activeDisposition: controlledActive,
  onDispositionChange,
  onEvidenceClick,
}) => {
  const firstDisposition = options[0]?.disposition ?? "";
  const [internalActive, setInternalActive] = useState(
    controlledActive ?? firstDisposition
  );

  const activeDisposition = controlledActive ?? internalActive;

  useEffect(() => {
    if (controlledActive !== undefined) return;
    if (
      options.length > 0 &&
      !options.some((o) => o.disposition === internalActive)
    ) {
      setInternalActive(options[0].disposition);
    }
  }, [controlledActive, internalActive, options]);

  const handleDispositionChange = (disposition: string) => {
    if (controlledActive === undefined) {
      setInternalActive(disposition);
    }
    onDispositionChange?.(disposition);
  };

  const activeOption = options.find(
    (option) => option.disposition === activeDisposition
  );

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden bg-white">
      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-3">
        <div className="flex flex-col gap-3">
          <ClinicalProgressionMetrics
            metrics={metrics}
            workingDrg={workingDrg}
          />

          <DispositionOptionTabs
            options={options}
            activeDisposition={activeDisposition}
            onDispositionChange={handleDispositionChange}
          />

          {options.length === 0 ? (
            <p className="text-sm text-gray-500">
              Predicted disposition data will appear here once available.
            </p>
          ) : (
            <DispositionOptionContent
              option={activeOption}
              onEvidenceClick={onEvidenceClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PredictiveDispositionPanel;
